import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { PriceContextProvider } from "@/components/Price/price/context/price.context";

type Props = {
    price: number;
    strikeThroughPrice?: number | null;
    conversionPrice?: number | null;
    conversionUnit?: string | null;
    size: "xs" | "sm" | "md" | "lg" | "xl";
    className?: string;
    children: ReactNode;
};

export const Base = ({
    price,
    strikeThroughPrice,
    conversionPrice,
    conversionUnit,
    size,
    className,
    children
}: Props) => {
    return (
        <PriceContextProvider
            price={price}
            strikeThroughPrice={strikeThroughPrice}
            conversionPrice={conversionPrice}
            conversionUnit={conversionUnit}
            size={size}
        >
            <div
                className={cn(
                    "tw:flex tw:flex-col tw:w-fit tw:items-end",
                    className
                )}
            >
                {children}
            </div>
        </PriceContextProvider>
    );
};
